export const LEVEL_REQUIRED_TO_UNLOCK_SPECIAL_ABILITY = 3
export const MINIMUM_LEVEL_REQUIRED_FOR_METROPOLIS = 4
